import Vue from 'vue'
import Vuex from 'vuex'
import OfflineStorage from '../utils/offlineStorage'
import router from '../router'
import auth from '../utils/auth'
import eggApi from '../api/eggApi'
import graphApi from '../api/graphApi'
import printer from '../utils/printer'
// import realsenseCamera from '../utils/realsenseCamera'



Vue.use(Vuex)
Vue.config.devtools = true

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    isOnline: navigator.onLine,
    settings: {},
    userProfile: null,
    printer: null,
    printerConnected: false,
    printerData: {}
  },
  mutations: {
    REPLACE_STATE_PROP: (state, payload) => {
      state[payload.property] = payload.data;
    }
  },
  actions: {
    async initializeStore(context) {
      // Create Printer Object and Retrieve Printer Settings
      context.commit("REPLACE_STATE_PROP", { property: "printer", data: new printer()});
      context.commit("REPLACE_STATE_PROP", { property: "printerConnected", data: false });

      //let deviceName = await realSenseCamera.getDeviceName() ?? "Unknown";

      let deviceName = "CCD-28433L"

      // Get Settings
      let settings = await OfflineStorage.getItem("settings");
      if (settings == null) {
        settings = {
          isDarkMode: false,
          deviceName: deviceName,
          farms: [],
          // farmMiniGens: [],
          badges:[],
          eggGrades: [],
          autoCut: false,
          label: 0
        };
        await OfflineStorage.setItem("settings", settings);
      }
      // Catches existing settings where MGs and Lines does not exist and adds it. Delete/replace on next deployment.
      if (settings.deviceName == null) {
        settings.deviceName = deviceName;
        await OfflineStorage.setItem("settings", settings);
      }
      context.commit("REPLACE_STATE_PROP", { property: 'settings', data: settings });

      context.state.printer.setCutOption(settings.autoCut ? 1 : 2);

      // Get User Profile
      let userProfile = await OfflineStorage.getItem('userProfile');
      if (!context.state.isOnline && userProfile != null) {
        context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: userProfile });

        if (router.currentRoute && router.currentRoute.path !== '/') {
          router.push({ path: '/' });
        }
        return;
      }

      if(context.state.isOnline) {
        const response = await auth.ssoSilent();
        if (response) {
          context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: true });
          setUserProfile(context);
        }
      }
    },
    async storeSignIn(context) {
      await auth.signIn();

      context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: true });
      
      setUserProfile(context);

      if (router.currentRoute.path !== '/') {
        router.push({ path: '/' });
      }
    },
    async storeSignOut(context) {
      auth.signOut();

      context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: null });
      context.commit("REPLACE_STATE_PROP", { property: "isAuthenticated", data: false });

      await OfflineStorage.setItem('userProfile', null);

      if (router.currentRoute.path !== '/signin') {
        router.push({ path: '/signin' });
      }
    },
    async setOnlineStatusInStore(context, isOnline) { 
      context.commit('REPLACE_STATE_PROP', { property: 'isOnline', data: isOnline });
      if (isOnline && 
        !context.state.isAuthenticated) {
          await auth.ssoSilent(context);
      }
    },
    updateSettingsInStore(context, settings) { 
      context.commit('REPLACE_STATE_PROP', { property: 'settings', data: settings });
      OfflineStorage.setItem('settings', settings);
    },
    async loadFarmSettingsFromServer(context, settings){
      settings.farms = await eggApi.getFarms();
      if (settings.farms.length == 1) settings.currentFarm = settings.farms[0].farmCode;
      if(settings.currentFarm) {
        const [eggGrades, farmLines, farmMiniGens, badges, referenceBadges, farmOperators, farmVisionOperators, farmHouses, userContext] = 
        await Promise.all([
          eggApi.getEggGrades(),
          eggApi.getFarmLines(true, settings.currentFarm),
          eggApi.getFarmMiniGens(settings.currentFarm),
          eggApi.getFarmBadges(settings.currentFarm),
          eggApi.getReferenceBadges(settings.currentFarm),
          eggApi.getFarmOperators(settings.currentFarm),
          eggApi.getVisionFarmOperators(settings.currentFarm),
          eggApi.getFarmHouses(settings.currentFarm),
          eggApi.getUserContext()
        ]);
        settings.eggGrades = eggGrades;
        settings.farmLines = farmLines;
        settings.farmMiniGens = farmMiniGens;
        settings.badges = badges;
        settings.referenceBadges = referenceBadges;
        settings.farmOperators = farmOperators;
        settings.farmVisionOperators = farmVisionOperators;
        settings.farmHouses = farmHouses;
        settings.userContext = userContext;
      }

      context.commit("REPLACE_STATE_PROP", { property: 'settings', data: settings });
      await OfflineStorage.setItem("settings", settings);
    },
    async updatePrinterData(context) {
      var printerData = context.state.printer.getPrinterData();
      context.commit("REPLACE_STATE_PROP", { property: "printerData", data: printerData });
      try {
        await OfflineStorage.setItem("printerData", printerData);
      }
      catch (error) {
        console.log('Error updating printer data in local storage.');
        console.log(error);
      }
    },
    async updatePrinterConnectionStatus(context) {
      var isConnected = context.state.printer.isConnected();
      if(isConnected) {
        setTimeout(() => context.dispatch('updatePrinterConnectionStatus'), 1000);
      }
      context.commit("REPLACE_STATE_PROP", { property: "printerConnected", data: isConnected });
      try {
        await OfflineStorage.setItem("printerConnected", isConnected);
      }
      catch (error) {
        console.log('Error updating printer connection status in local storage.');
        console.log(error);
      }
      context.dispatch('updatePrinterData');
    }
  }
})

async function setUserProfile(context) {
  const userProfile = await graphApi.getUserProfile();
  if (userProfile) {
    context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: userProfile });
    await OfflineStorage.setItem('userProfile', userProfile);
  } else {
    context.commit("REPLACE_STATE_PROP", { property: "userProfile", data: null });
    await OfflineStorage.setItem('userProfile', null);
  }
}